import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import React from 'react';
import PlaylistContentTree from 'components/PlaylistContentTree';
import { getIsPlaylistEditable } from 'utils/privileges';
import { augmentPlaylistContentWithParentId } from 'utils/asset/augmentPlaylistContentWithParentId';
import { arrayToTree } from 'utils/tree';
import useOnWebAssetClick from '../useOnWebAssetClick';
function ContentItemList(_ref) {
  var _contentItems$filter$;
  var playlist = _ref.playlist;
  var _useOnWebAssetClick = useOnWebAssetClick(),
    onWebAssetClick = _useOnWebAssetClick.onWebAssetClick;
  var isEditablePlaylist = getIsPlaylistEditable({
    playlist: playlist
  });
  var contentItems = playlist.content;
  var nextContentItemId = (_contentItems$filter$ = contentItems.filter(function (a) {
    return a.type !== 'section';
  }).find(function (a) {
    return a.userContentStatus !== 'completed' && a.optional === false;
  })) === null || _contentItems$filter$ === void 0 ? void 0 : _contentItems$filter$.id;
  var contentAsTree = arrayToTree(augmentPlaylistContentWithParentId(contentItems));
  return /*#__PURE__*/React.createElement(PlaylistContentTree, {
    parentPlaylist: playlist,
    playlistContent: contentAsTree,
    isEditablePlaylist: isEditablePlaylist,
    nextContentItemId: nextContentItemId,
    onWebAssetClick: onWebAssetClick
  });
}
export default ContentItemList;